var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDashboard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.618 23h2.427a4.854 4.854 0 0 0 4.853-4.854v-7.635A4.85 4.85 0 0 0 20.56 6.36l-6.067-3.678a4.85 4.85 0 0 0-5.032 0L3.394 6.36a4.85 4.85 0 0 0-2.338 4.15v7.636A4.854 4.854 0 0 0 5.91 23h2.427m7.28 0v-4.854a3.64 3.64 0 1 0-7.28 0V23m7.28 0h-7.28"
})));
export default SvgDashboard;